import { GoogleAPIPlace } from 'models/purchaseFlow'
import { Nullable } from 'models/helpers'

/** checks if address is valid (is set and has route, and street number) */
export const isAddressValid = (googlePlace: Nullable<GoogleAPIPlace>) => {
  if (!googlePlace) return false
  if (!googlePlace.address_components) return false
  let foundRoute = false
  let foundStreetNumber = false
  for (let component of googlePlace.address_components) {
    for (let type of component.types) {
      switch (type) {
        case 'route':
          foundRoute = true
          break
        case 'street_number':
          foundStreetNumber = true
          break
      }
    }
  }
  return (foundRoute && foundStreetNumber)
}
